/**
 * for drilldown
 * @param  {object} obj  the whole data
 * @param  {array}  arr  output from catsInOneCntForLine function
 * @param  {string} name country name
 * @return {array}       as below
 */
/*
[
  {
    name: "Cocoa",
    id: "Cocoa",
    max: 100,
    data: [
      [
        "Cocoa beans",
        [123, 12, 12,...]
      ],
      [
        "Chocolates",
        [123, 12, 12,...]
      ],
    ]
  },
  {
    name: "Fish",
    id: "Fish",
    max: 34,
    data: [
      [
        "Catfish",
        [123, 12, 12,...]
      ],
      [
        "Dogfish",
        [123, 12, 12,...]
      ],
    ]
  }
]
*/
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.subcatsInOneCnt = subcatsInOneCnt;

function subcatsInOneCnt(obj, arr, name) {
  var output = [];

  arr.forEach(function (d) {

    var myObj = {
      name: d['name'],
      id: d['name'],
      max: 0,
      data: []
    };

    var max = 0;

    var _loop = function (subCat) {
      if (subCat === 'total') return 'continue';
      var cnts = Object.keys(obj[d['name']][subCat]);

      cnts.forEach(function (c) {
        if (c === name) {

          obj[d['name']][subCat][c].forEach(function (dd) {
            max = Math.max(max, dd);
          });

          myObj['data'].push([subCat, obj[d['name']][subCat][c]]);

          myObj['data'].sort(function (a, b) {
            return b[1].reduce(function (b1, b2) {
              return b1 + b2;
            }) - a[1].reduce(function (a1, a2) {
              return a1 + a2;
            });
          });
        }
      });
    };

    for (var subCat in obj[d['name']]) {
      var _ret = _loop(subCat);

      if (_ret === 'continue') continue;
    }
    myObj.max = max;
    output.push(myObj);
  });

  //console.dir(output)
  return output;
}
//# sourceMappingURL=data:application/json;base64,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